import React from "react";
import { makeStyles, Modal, Typography } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import { useTranslation } from "react-i18next";

import { CarForm } from "../Forms/CarForm";
import { StoreContext } from "../../store/StoreContext";

const useStyles = makeStyles((theme) => ({
  modal: {
    position: "absolute",
    width: 400,
    top: "15%",
    left: "35%",
    backgroundColor: "#fff",
    textAlign: "center",
    [theme.breakpoints.down("sm")]: {
      width: 350,
      left: "25%",
    },
    [theme.breakpoints.down("xs")]: {
      width: 300,
      left: "10%",
    },
  },
  closeWrapper: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  closeButton: {
    width: 30,
    height: 30,
    padding: "10px 10px 0 0",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "&:hover": {
      cursor: "pointer",
      color: "#aaa",
    },
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
    marginBottom: 5,
  },
  form: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "10px 30px 30px",
  },
}));

export const AddCarModal = ({ show, onClose }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { addCar } = React.useContext(StoreContext);

  const onSubmit = async (values) => {
    const {
      trackerIMEI,
      department,
      carNumber,
      model,
      trackerSimNumber,
      color,
      trackingColor: track_color,
    } = values;
    const car = {
      model,
      department,
      sim_imei: trackerIMEI,
      sim_number: trackerSimNumber,
      number: carNumber,
      color,
      track_color,
      is_active: false,
    };
    addCar(car);
    onClose();
  };

  return (
    <div>
      <Modal open={show} onClose={onClose}>
        <div className={classes.modal}>
          <div className={classes.closeWrapper}>
            <div className={classes.closeButton} onClick={onClose}>
              <Close />
            </div>
          </div>
          <Typography variant="h6">{t("ADD_CAR_MODAL")}</Typography>
          <div>
            <CarForm
              onSubmit={onSubmit}
              classes={classes}
              buttonTitle={t("ADD")}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};
